import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    currentTheme: 'dark' as 'light' | 'dark',
  }),

  actions: {
    toggleTheme() {
      this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
      this.applyTheme()
      this.saveTheme()
    },

    setTheme(theme: 'light' | 'dark') {
      this.currentTheme = theme
      this.applyTheme()
      this.saveTheme()
    },

    applyTheme() {
      if (import.meta.client) {
        const root = document.documentElement
        root.classList.remove('theme-light', 'theme-dark')
        root.classList.add(this.currentTheme === 'dark' ? 'theme-dark' : 'theme-light')
      }
    },

    saveTheme() {
      if (import.meta.client) {
        localStorage.setItem('theme', this.currentTheme)
      }
    },

    initTheme() {
      if (import.meta.client) {
        // Принудительно устанавливаем темную тему
        this.currentTheme = 'dark'
        this.applyTheme()
        this.saveTheme()
      }
    },
  },
})
